import type { ReactNode } from 'react';
import { useGeneratorContext } from '../GeneratorContext';
import type { NodeRenderer } from '../generateNodes';
import type { LinkNode } from '../schema';
import styles from './renderers.module.css';

function InternalLink({
  targetScreenId,
  children,
}: {
  targetScreenId: string;
  children: ReactNode;
}) {
  const { setCurrentScreenId } = useGeneratorContext();
  return (
    <button
      type="button"
      className={styles.internalLink}
      onClick={() => setCurrentScreenId(targetScreenId)}
    >
      {children}
    </button>
  );
}

export const LinkRenderer: { link: NodeRenderer<LinkNode> } = {
  link: ({ node, nodesToJSX }) => {
    const children = nodesToJSX({ nodes: node.children });

    if ('targetScreenId' in node.attributes) {
      return (
        <InternalLink targetScreenId={node.attributes.targetScreenId}>
          {children}
        </InternalLink>
      );
    }

    const { to, external = true } = node.attributes;
    return (
      <a
        href={to}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
        className={styles.externalLink}
      >
        {children}
      </a>
    );
  },
};
